import type { FaireProductEntity } from "../../entity_types/product";

export const driftless_studios_10: FaireProductEntity = {
  token: "driftless-studios-10",
  type: "product",
  name: "40 Oz. Custom Saying Handled Tumbler With Straw",
  brandName: "Driftless Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/18d06fb0c1d21a3da995a5661ca20c69be790ec840133ad23e49a7cfa3a09e81.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 18.5,
  msrpDollars: 32,
  freeShipping: false,
  isBestseller: true,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
